/**
 * API Gateway
 * API Gateway Единая точка входа для android, ios и web.  Модели ответов сервиса соответствуют спецификации, кроме случаев, когда возможны технические ответы (например, от ratelimiter или qrator). 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Ошибка в запросе
 */
export interface BadRequestResponse { 
    code: BadRequestResponse.CodeEnum;
    message: string;
    errors?: Array<object>;
}
export namespace BadRequestResponse {
    export type CodeEnum = 'BAD_REQUEST';
    export const CodeEnum = {
        BadRequest: 'BAD_REQUEST' as CodeEnum
    };
}


